<template>
  <custom-dialog
    class="deliver-goods-dialog"
    width="1200px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <deliver-goods-order :orderId="model.data.orderId" @getList="needDevicesChange"></deliver-goods-order>
      <div class="ub" style="margin-top: 15px;">
        <deliver-stock-device-num
          ref="stockDeviceNum"
          :needDevices="needDevices"
        ></deliver-stock-device-num>
        <div class="ubv ub-ac ub-xc" style="padding: 0 16px;">
          <div class="btn" @click="addDevice">
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="btn2" @click="removeDevice">
            <i class="el-icon-arrow-left"></i>
          </div>
        </div>
        <deliver-goods-deliver :needDevices="needDevices" ref="goodsDeliver"></deliver-goods-deliver>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{
        $t('Common.com_confirm')
      }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

import deliverGoodsOrder from './deliver_goods_order';
import deliverStockDeviceNum from './deliver_stock_device_num';
import deliverGoodsDeliver from './deliver_goods_deliver';

export default {
  mixins: [dialogMixins],
  components: {
    deliverGoodsOrder,
    deliverStockDeviceNum,
    deliverGoodsDeliver
  },
  props: {
  },
  data() {
    return {
      // 订单需求设备数量表
      needDevices: []
    };
  },
  methods: {
    needDevicesChange(list) {
      this.needDevices = list;
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      // this.$refs.goodsDeliver.getSelectedDevice()
      const deviceList = this.$refs.goodsDeliver.getSelectedDevice();
      if (!deviceList.length) {
        this.$message.error(this.$t('crm_deliver_goods_dialog.qxzyfhdsb'));
        return;
      }
      const reqData = {
        deviceList: this.$refs.goodsDeliver.getSelectedDevice(),
        orderId: this.model.data.orderId,
        orderCode: this.model.data.orderCode
      };
      this.$postJSON(apis.transferOrderDeliver, reqData, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.$emit('success');
        this.closeDialog();
      });

    },
    addDevice() {
      const deviceIn = this.$refs.stockDeviceNum.getDeviceIn();
      this.$refs.goodsDeliver.addDevice(deviceIn);
      this.$refs.stockDeviceNum.clearSelection();
    },
    removeDevice() {
      this.$refs.goodsDeliver.removeDevice();
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss">
.deliver-goods-dialog {
  // 去除底部横线
  // .el-table::before {
  //   height: 0;
  // }

  .dialog-body {
    overflow-x: hidden;
  }

  .box {
    // width: 380px;
    margin-top: 16px;
    padding: 0 16px 5px 16px;
    border: 1px solid #dee2e6;
    position: relative;
  }
  .ub-fl {
    width: 580px;
  }
  .ubv {
    flex: 1;
  }
  .btn {
    cursor: pointer;
    width: 24px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    background-color: #00afff;
    border: 1px solid rgba(24, 144, 255, 1);
    text-align: center;
    color: #ffffff;
  }
  .btn2 {
    cursor: pointer;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    text-align: center;
    color: #000000;
    margin-top: 10px;
  }
  .title {
    color: #35405b;
    font-weight: bold;
    font-size: 14px;
  }
}
</style>
